export function fullName({
  firstName,
  lastName,
  middleName,
}: {
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  middleName?: string | null | undefined;
}) {
  return [firstName, middleName, lastName].filter(Boolean).join(' ');
}
